<template>
  <div class="d-flex flex-column align-center justify-center" style="min-height:100vh">
    <div
      class="header d-flex flex-column align-center py-10"
      style="position:fixed; top: 0; width:100%; background-color:white; z-index:1"
    >
      <h2
        class="mb-0"
      >Διαθέσιμοι {{$route.params.type === 'psychologists' ? 'ψυχολόγοι' : 'ιατροί'}}</h2>
      <h2 class="mb-0">Doctor Next 2 Me</h2>
      <v-btn
        color="rgb(0,170,221)"
        rounded
        depressed
        :loading="loading"
        text
        class="white--text text-capitalize"
        @click="refresh"
      >
        <p class="mb-0 font-weight-regular" style="color:rgb(0,170,221)">Ανανέωση</p>
      </v-btn>

      <p class="mb-0">
        {{people.length}} αποτελέσματα για
        <span class="font-weight-bold">{{getDoctorType()}}</span>
      </p>

       <v-btn
        v-if="!($route.params.doctorType===undefined)"
        color="rgb(0,170,221)"
        rounded
        depressed
        :loading="loading"
        text
        class="white--text text-capitalize"
        @click="aferesh"
      >
        <p class="mb-0 font-weight-regular" style="color:rgb(0,170,221)">Αφαίρεση ειδικότητας</p>
      </v-btn>
    </div>

    <div style="margin-top:200px; padding: 0 50px;" v-if="!loading && people.length === 0">
      <p
        class="text-center"
      >Δυστυχώς δεν βρέθηκαν διαθέσιμοι {{$route.params.type === 'psychologists' ? 'ψυχολόγοι' : 'ιατροί'}} αυτήν τη στιγμή.</p>

      <p class="text-center">Παρακαλώ προσπαθήστε αργότερα.</p>
    </div>

    <div
      v-if="!loading"
      class="list d-flex flex-column align-center justify-center"
      style="margin-top:250px"
    >
      <div v-for="(person, index) in people" :key="index" class="box mb-5">
        <div class="d-flex">
          <div class="d-flex flex-column ml-2">
            <p class="mb-0 text-center">Dr. {{person.firstName}} {{person.lastName}}</p>
            <p
              class="mb-0 text-center"
              style=" color:rgb(74,74,74)"
              v-if="$route.params.type==='doctors'"
            >{{person.doctorTypeName}}</p>
            <p
              class="mb-0 text-center"
              style="font-size:13px; color:rgb(74,74,74)"
            >{{person.isPublicDoctor ? 'Ιατρός Ε.Σ.Υ.' : ''}}</p>
            <p
              class="mt-1 text-center"
              style="font-size:14px; color:rgb(74,74,74)"
            >Δήμος: {{person.currentMunicipalityName}}</p>
          </div>
        </div>
        <div class="line"></div>
        <v-btn
          depressed
          rounded
          color="rgb(0,170,221)"
          class="white--text text-capitalize mt-4"
          @click="buttonClick(person.doctorId)"
        >
          <p class="mb-0 font-weight-regular">Δωρεάν βιντεοκλήση</p>
        </v-btn>
      </div>
    </div>

    <v-progress-circular
      color="rgb(0,170,221)"
      class="justify-self-center align-self-center"
      v-else
      indeterminate
    ></v-progress-circular>

    <v-dialog width="400" v-model="dialog">
      <v-card>
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center pt-1">
            <p class="text-center mb-0">
              H χρήση της εφαρμογής είναι
              <span class="font-weight-bold">ΔΩΡΕΑΝ</span> και θα πρέπει να γίνεται
              <span
                class="font-weight-bold"
              >για παροχή ιατρικών συμβουλών και υποστήριξης.</span>
            </p>
            <p class="text-center mb-0">
              Για λόγους διαφύλαξης του σκοπού της εφαρμογής η
              <span
                class="font-weight-bold"
              >κλήση σε γιατρό συνιστάται να περιορίζεται στα 10 λεπτά.</span>
            </p>
            <p class="text-center mb-0">
              Εάν τη χρησιμοποιήσετε για παραπάνω χρόνο ή για σκοπούς που δεν έχουν να κάνουν
              με παροχή άμεσης ιατρικής υποστήριξης (πχ χρόνια νοσήματα), οι συνεργαζόμενοι
              ιατροί έχουν το δικαίωμα να μην σας εξυπηρετήσουν και να το δηλώσουν ώστε να
              αποκλειστείτε από μελλοντική χρήση της με βάση τους ορους χρήσης
              <span
                style="color:rgb(0,170,221);"
              ></span> της εφαρμογής
            </p>
            <v-btn
              depressed
              rounded
              color="rgb(0,170,221)"
              class="white--text mt-1"
              width="270"
              :loading="callLoading"
              @click="call"
            >
              <p class="mb-0" style="text-transform:initial">Το κατανοώ και θέλω να συνεχίσω</p>
            </v-btn>

            <v-btn text @click="dialog =false" class="text-capitalize mt-1">
              <p class="mb-0">Ακύρωση</p>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog width="400" v-model="unavailableDialog">
      <v-card>
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center pa-5">
            <h2 class="black--text text-center">Ο ειδικός που επιλέξατε δεν είναι διαθέσιμος.</h2>
            <v-btn
              depressed
              rounded
              color="rgb(0,170,221)"
              class="white--text text-capitalize mt-5"
              @click="refresh"
            >
              <p class="mb-0">Ανανέωση</p>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="declined" width="400">
      <v-card>
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center pa-2">
            <p
              class="text-center black--text"
            >Ο ειδικός που καλέσατε δεν μπορεί να μιλήσει αυτή τη στιγμή. Δοκιμάστε με κάποιον άλλο από τους διαθέσιμους</p>
            <v-btn
              rounded
              depressed
              color="rgb(0,170,221)"
              class="white--text text-capitalize"
              @click="closeDeclinedDialog"
            >
              <p class="mb-0">ΟΚ</p>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="timeout" width="400">
      <v-card>
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center pa-2">
            <p
              class="text-center black--text"
            >Ο ειδικός που καλέσατε δεν απαντά, παρακαλώ δοκιμάστε να καλέσετε κάποιον άλλο</p>
            <v-btn
              rounded
              depressed
              color="rgb(0,170,221)"
              class="white--text text-capitalize"
              @click="closeTimeoutDialog"
            >
              <p class="mb-0">ΟΚ</p>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="permissionDialog" width="400">
      <v-card>
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h2
              class="black--text font-weight-bold text-center pa-5"
            >Έχετε απενεργοποιήσει τη χρήση κάμερας ή/και μικροφώνου στον browser σας. Πρέπει να τα ενεργοποιήσετε για να μπορείτε να συνεχίσετε με κάποια βιντεοκλήση.</h2>
            <v-btn
              depressed
              rounded
              color="rgb(0,170,221)"
              class="white--text"
              @click="permissionDialog=false"
            >
              <p class="mb-0">OK</p>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  created() {
    // navigator.permissions
    //   .query({ name: "camera" })
    //   .then(res => {
    //     //   console.log(res.state);
    //     this.camera = res.state;

    //     return navigator.permissions.query({ name: "microphone" });
    //   })
    //   .then(res => {
    //     this.microphone = res.state;
    //   })
    //   .catch(err => console.log(err));

    axios
      .get(
        `${process.env.VUE_APP_BASE_URL}/traveller/getVideoCallDoctors${
          this.$route.params.type === "doctors"
            ? this.$route.params.doctorType === undefined
              ? ""
              : "/" + this.$route.params.doctorType
            : this.$route.params.type === "psychologists"
            ? "/99"
            : ""
        }`
      )
      .then(res => {
        console.log(res.data);
        this.loading = false;
        this.people = res.data;
        //this.people = []
      })
      .catch(err => {
        this.loading = false;
        console.log(err);
      });
  },
  data() {
    return {
      callLoading: false,
      people: [],
      loading: true,
      dialog: false,
      unavailableDialog: false,
      doctorId: null,
      camera: null,
      microphone: null,
      permissionDialog: false
    };
  },
  computed: {
    timeout() {
      return this.$store.state.timeout;
    },
    declined() {
      return this.$store.state.declined;
    }
  },
  methods: {
    aferesh(){
      this.$router.replace('/emergency/doctors/')
      this.refresh()
    },
    getDoctorType() {
      if (this.$route.params.type === "psychologists") return "Ψυχολόγους";

      if (this.$route.params.doctorType === undefined) return "Ιατρούς";

      return this.$store.state.doctors.find(
        item => item.option_key == this.$route.params.doctorType
      ).option_value;
    },
    buttonClick(id) {
      // if (this.camera === "denied" || this.microphone === "denied") {
      //   this.permissionDialog = true;
      // } else {
      this.dialog = true;
      this.doctorId = id;
      // }
    },
    closeDeclinedDialog() {
      this.$store.dispatch("declined", false);
    },
    select(doctorId) {
      this.$store
        .dispatch("setDoctor", doctorId)
        .then(() => {
          return axios.post(
            `${process.env.VUE_APP_BASE_URL}/traveller/isDoctorsAvailableForVideoCall`,
            {
              doctorId: doctorId
            }
          );
        })
        .then(res => {
          console.log(res);
          if (res.data) {
            this.dialog = true;
          } else {
            this.unavailableDialog = true;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    closeTimeoutDialog() {
      this.$store.dispatch("timeout", false);
    },
    // refresh() {
    //   this.unavailableDialog = false;
    //   this.$router.go();
    // },
    call() {
      let available;
      this.callLoading = true
      axios
        .post(
          `${process.env.VUE_APP_BASE_URL}/traveller/isDoctorsAvailableForVideoCall`,
          {
            doctorId: this.doctorId
          }
        )
        .then(res => {
          available = res.data;

          return this.$store.dispatch("setDoctor", this.doctorId);
        })
        .then(() => {
          console.log("available", available);
          if (available) {
            this.$router.push("/room");
            this.callLoading = false
          } else {
            this.dialog = false;
            this.unavailableDialog = true;
            this.callLoading = false
          }
        })
        .catch(err => {
          this.callLoading = false
        });
    },
    refresh() {
      this.loading = true;
      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}/traveller/getVideoCallDoctors${
            this.$route.params.type === "doctors"
              ? this.$route.params.doctorType === undefined
                ? ""
                : "/" + this.$route.params.doctorType
              : this.$route.params.type === "psychologists"
              ? "/99"
              : ""
          }`
        )
        .then(res => {
          console.log(res.data);
          this.unavailableDialog=false
          this.loading = false;
          this.people = res.data;
          //this.people = []
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  border: 2px solid rgb(240, 240, 240);
  padding: 15px 20px;
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.line {
  width: 100%;
  background-color: rgb(240, 240, 240);
  height: 1px;
}

.profilePic {
  height: 65px;
  border-radius: 50%;
}

@media only screen and (min-width: 600px) {
  .box {
    width: 600px;
  }
}
</style>